module.exports = __webpack_public_path__ + "static/media/shortness-of-breath.8a244c12.svg";